export type PickerViewMode = "overview" | "wheel";

export const PICKER_VIEW_STORAGE_KEYS = {
  compact: "pickem.picksView.compact",
  desktop: "pickem.picksView.desktop",
} as const;

export const defaultPickerViewMode = (compact: boolean): PickerViewMode =>
  compact ? "wheel" : "overview";

export const readPickerViewMode = (
  compact: boolean,
  storage?: Pick<Storage, "getItem">,
): PickerViewMode => {
  const fallback = defaultPickerViewMode(compact);
  if (!storage) return fallback;

  try {
    const stored = storage.getItem(
      compact
        ? PICKER_VIEW_STORAGE_KEYS.compact
        : PICKER_VIEW_STORAGE_KEYS.desktop,
    );
    return stored === "overview" || stored === "wheel" ? stored : fallback;
  } catch {
    return fallback;
  }
};

export const writePickerViewMode = (
  compact: boolean,
  mode: PickerViewMode,
  storage?: Pick<Storage, "setItem">,
) => {
  if (!storage) return;
  try {
    storage.setItem(
      compact
        ? PICKER_VIEW_STORAGE_KEYS.compact
        : PICKER_VIEW_STORAGE_KEYS.desktop,
      mode,
    );
  } catch {
    // A blocked storage API should never prevent the user from switching views.
  }
};
